export default __webpack_public_path__ + "static/media/s3-008.ffecfac8.jpg";